const { isArray } = Array

// polite interval helper using rAF
const requestInterval = (fn, delay) => {
  let start = Date.now()
  let stop
  function loop() {
    Date.now() - start < delay || ((start += delay), fn())
    stop || requestAnimationFrame(loop)
  }
  requestAnimationFrame(loop)
  return {
    clear: function () {
      stop = 1
    },
  }
}

// round value by step or snapStep
const roundBy = (v, step) => Math.round(v / step) * step

// round value to specified precision
const roundTo = (n, precision = 0) => {
  const multiplicator = Math.pow(10, precision)
  n = parseFloat((n * multiplicator).toFixed(11))
  return Math.round(n) / multiplicator
}

const getPrecision = value => {
  const precision = `${value}`.split(".")
  return precision.length > 1 ? precision[1].length : 0
}

const getClosest = (vs, v) =>
  vs.reduce((c, n) => (Math.abs(v - c) <= Math.abs(v - n) ? c : n))

const getValue = (value, props, state = {}) => {
  const { interpolate, snapStep, customDomain } = props
  const [min, max] = getDomain(props)
  const isActive = state.isActive || state.playInterval
  const step =
    customDomain || (interpolate && isActive) ? props.step : props.snapStep

  if (typeof value === "undefined")
    value = [roundTo(min + (max - min) / 2, getPrecision(snapStep))]

  if (!isArray(value)) value = [value]

  value = value.map(v => roundTo(roundBy(v, step), getPrecision(step)))

  value =
    value.length > 1
      ? [
          value[0] < value[1] ? (value[0] > min ? value[0] : min) : value[1],
          value[1] < max ? (value[1] > value[0] ? value[1] : value[0]) : max,
        ]
      : [value[0] <= max ? (value[0] >= min ? value[0] : min) : max]

  return !customDomain || (interpolate && isActive)
    ? value
    : value.map(v => getClosest(customDomain, v))
}

const getPublicValue = (v, props, state) => {
  if (props) v = getValue(v, props, state)
  return v.length === 1 ? v[0] : v
}

const getTooltipValue = (value, { snapStep, tooltipFormat = v => v }) =>
  value.map(v => tooltipFormat(roundBy(v, snapStep)))

const getDomain = ({ min, max, customDomain }) => {
  return customDomain
    ? [customDomain[0], customDomain[customDomain.length - 1]]
    : [min, max]
}

const getPos = (v, min, max) => ((v - min) / (max - min)) * 100

const getHandlePosition = (value, props) => {
  const [min, max] = getDomain(props)
  return isArray(value)
    ? value.map(v => getPos(v, min, max))
    : getPos(value, min, max)
}

const getSnapPoints = ({ min, max, customDomain, snapStep }) => {
  if (customDomain) return customDomain
  const precision = getPrecision(snapStep)
  const snapSteps = []
  for (let i = min; i <= max; i = roundTo(i + snapStep, precision))
    snapSteps.push(i)
  return snapSteps
}

export {
  requestInterval,
  getPrecision,
  getValue,
  getPublicValue,
  getTooltipValue,
  getDomain,
  getHandlePosition,
  getSnapPoints,
}
